import { Trans, useTranslation } from 'react-i18next'

import imgUrl from '../../../../images/big_search.svg'

import { useSearchFiltersWithoutPeriod } from '../../../hooks/useSearchFilters'
import { getCurrentSearchObj } from '../../../../helpers/location'

type Props = {
  isSearch?: boolean
  isLimitedSearch?: boolean
  incomparable?: boolean
  message?: string
}

const NoArticlesPage = ({ isSearch, isLimitedSearch = false, incomparable, message }: Props) => {
  const { t } = useTranslation()
  const searchFilters = useSearchFiltersWithoutPeriod()
  const { expression } = getCurrentSearchObj()

  const getDefaultMessage = () => {
    if (isLimitedSearch) {
      return t('Click on one of the profiles or tags in left column')
    }

    if (!searchFilters.length && !expression) {
      return t('Use search field to search for news or click on one of the profiles in left column')
    }

    if (isSearch) {
      return t('Sorry, this search did not return any hits')
    }

    if (incomparable) {
      return t('Sorry, the previous period had no articles. Please select a longer current period')
    }

    return t('Use search field to search for news or click on one of the profiles in left column')
  }

  return (
    <div
      data-cy="no-articles"
      className="flex h-full flex-col items-center justify-center text-center text-xl font-bold text-sky.cloudy "
    >
      <img className="mb-4" src={imgUrl} width="212" alt="Search" loading="lazy" />
      <Trans>{message || getDefaultMessage()}</Trans>
    </div>
  )
}

export default NoArticlesPage
